export const HONEYBADGER_IGNORE_PATTERNS = [
  /Can't find variable: _pcmBridgeCallbackHandler/,
  /Cannot redefine property: src/,
  /cdn.cookielaw.org/,
  /formatToParts/,
  /GraphQL error: Unauthorised/,
  /otBannerSdk/,
  /ResizeObserver loop limit exceeded/,
  /stats.g.doubleclick.net/,
  /undefined is not an object (evaluating 'r.DomainData')/,
  /UnhandledPromiseRejectionWarning/,
  /window.unhandled/
];
